//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OperatorQuery: any = {
    GetOperatorService: Backofficebff + '/v1/operator/operators-combinedid',
    GetOperatorList: Backofficebff + '/v1/operator/operators',
    getOperatorListByRoleId: Backofficebff + '/v1/operator',
    GetRolesList: Backofficebff + '/v1/operator/role',
    GetOperatorRolesList: Backofficebff + '/v1/operator/selfroles?userKey=',
    GetRolesAuthorizationList: Backofficebff + '/v1/operator/role',
    SearchRolesByEndpoint: Backofficebff + '/v1/operator/role/search-by-endpoint',
    GetOperatorUpdate: Backofficebff + '/v1/operator/update',
    GetOperatorFindByUserName: Backofficebff + '/v1/operator/findby-username/',
    GetStaffs: Backofficebff + '/v1/operator/getstaffs',
};
